'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Controllable;

var _pick = require('../utils/underscore/pick');

var _pick2 = _interopRequireDefault(_pick);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropNames = require('../core/PropNames');

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = require('./utils');

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_FIELDS = ['value'];

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {Object}
 */
function _getDefaultProps(component, fields) {
  // shallow copy of defaultProps to use as the initial value to prevent mutation
  var defaultProps = _extends({}, component.defaultProps);

  return fields.reduce(function (defaults, field) {
    if (defaults.hasOwnProperty(field)) {
      defaults[(0, _PropNames.getDefaultPropName)(field)] = defaults[field];
      delete defaults[field];
    }
    return defaults;
  }, defaultProps);
}

/**
 * @param  {Object}
 * @param  {Array<string>}
 * @return {Object}
 */
function getDefaultPropTypes(originalPropTypes, fields) {
  return fields.reduce(function (propTypes, field) {
    var originalPropType = propTypes[field];
    if (typeof originalPropType !== 'function') {
      originalPropType = _react.PropTypes.any;
    }
    var notRequiredPropType = (0, _decorators.notRequired)(originalPropType);
    propTypes[(0, _PropNames.getDefaultPropName)(field)] = notRequiredPropType;
    propTypes[field] = notRequiredPropType;
    return propTypes;
  }, _extends({}, originalPropTypes));
}

/**
 * @param  {Array<string>}
 * @return {Object}
 */
function getHandlerPropTypes(fields) {
  return fields.reduce(function (propTypes, field) {
    propTypes[(0, _PropNames.getOnChangeName)(field)] = _react.PropTypes.func;
    return propTypes;
  }, {});
}

/**
 * @param  {ReactElement} instance
 * @param  {string} field
 * @param  {Object} event
 * @return {void}
 */
function handleChange(instance, field, evt) {
  (0, _invariant2.default)(evt && evt.target != null, (0, _getComponentName2.default)(instance.constructor) + ' handleChange: expected ' + 'argument in shape of SyntheticEvent ({target: value})');

  instance.setState(_defineProperty({}, field, evt.target.value));
  var onChange = instance.props[(0, _PropNames.getOnChangeName)(field)];
  if (typeof onChange === 'function') {
    onChange(evt);
  }
}

/**
 * @param  {React.Component}
 * @param  {Array<string>}
 * @return {React.Component}
 */
function Controllable(InputComponent) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FIELDS;

  var onChangeKeys = fields.map(_PropNames.getOnChangeName);
  var defaultProps = fields.map(_PropNames.getDefaultPropName);

  var controlledComponent = _react2.default.createClass({
    displayName: 'Controllable(' + (0, _getComponentName2.default)(InputComponent) + ')',

    propTypes: _extends({}, getDefaultPropTypes(InputComponent.propTypes, fields), getHandlerPropTypes(fields)),

    /**
     * @return {Object}
     */
    getDefaultProps: function getDefaultProps() {
      return _getDefaultProps(InputComponent, fields);
    },


    /**
     * @return {Object}
     */
    getInitialState: function getInitialState() {
      var defaults = (0, _pick2.default)(this.props, defaultProps);
      var initialState = {};
      Object.keys(defaults).forEach(function (defaultKey) {
        initialState[(0, _PropNames.getPropFromDefaultName)(defaultKey)] = defaults[defaultKey];
      });

      return initialState;
    },


    /**
     * @return {void}
     */
    componentWillMount: function componentWillMount() {
      var _this = this;

      var handlers = {};
      onChangeKeys.forEach(function (onChangeKey, i) {
        handlers[onChangeKey] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return handleChange.apply(undefined, [_this, fields[i]].concat(args));
        };
      });
      this.handlers = handlers;
      this._refCallback = (0, _utils.makeDecoratorRefCallback)(InputComponent, this);
    },


    /**
     * @return {void}
     */
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      fields.forEach(function (field) {
        if (_this2.props[field] !== undefined && nextProps[field] === undefined) {
          _this2.setState(_defineProperty({}, field, nextProps[(0, _PropNames.getDefaultPropName)(field)]));
        }
      });
    },


    /**
     * @return {Object}
     */
    getProps: function getProps() {
      var _this3 = this;

      var applicableProps = {};
      Object.keys(this.props).forEach(function (key) {
        if (defaultProps.indexOf(key) === -1 && _this3.props[key] !== undefined) applicableProps[key] = _this3.props[key];
      });

      return _extends({}, this.state, applicableProps, this.handlers);
    },


    /**
     * @return {React.Element}
     */
    render: function render() {
      return _react2.default.createElement(InputComponent, _extends({}, this.getProps(), { ref: this._refCallback }));
    }
  });

  (0, _utils.attachWrappedComponent)(controlledComponent, InputComponent);

  return controlledComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/decorators/Controllable.js
// module id = 30
// module chunks = 3 4 5